import React from "react";
import styles from "./CloseButton.module.css";

export default function CloseButton({ close }) {
  return <button class={styles.closeButton} onClick={() => close()}></button>;
}
